<ul class="menu-socials list-none p-0 m-0 overflow-hidden">
  @for (social of socialsGroup; track social.icon) {
    <li>
      <a
        pButton
        pRipple
        [href]="social.link"
        target="_blank"
        class="p-button-icon-only p-button-secondary p-button-rounded">
        <i [class]="social.icon"></i>
      </a>
    </li>
  }
</ul>
